var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrongSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "189px",
    viewBox: "0 0 350 189",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 350,
    height: 189
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platforma_ALL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    opacity: 0,
    transform: "translate(175.000000, 94.500000) scale(1, -1) translate(-175.000000, -94.500000) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(134.000000, 100.000000)",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,51.818212 C75.0654693,68.6780261 59.3859429,81 40.8067025,81 C18.2702052,81 0,62.8675592 0,40.5 C0,18.1324408 18.2702052,0 40.8067025,0 C48.7804144,0 56.2183314,2.26842222 62.5033863,6.19185661",
    id: "Stroke-42",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.899,10.4589 C76.153,17.9019 81.341,28.6809 81.341,40.6709 C81.341,42.0459 81.273,43.4049 81.14,44.7449",
    id: "Stroke-43",
    stroke: "#1D1D1B",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "32-px-close-2-copy",
    transform: "translate(21.000000, 21.000000)",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E8ECFF",
    points: "28.2875 0 40 11.7125 40 28.2875 28.2875 40 11.7125 40 0 28.2875 0 11.7125 11.7125 0"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.25,
    y1: 28.75,
    x2: 28.75,
    y2: 11.25,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.75,
    y1: 28.75,
    x2: 11.25,
    y2: 11.25,
    id: "Path"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M123.039,112.9912 C123.039,114.9352 121.463,116.5122 119.519,116.5122 C117.575,116.5122 116,114.9352 116,112.9912 C116,111.0482 117.575,109.4712 119.519,109.4712 C121.463,109.4712 123.039,111.0482 123.039,112.9912",
    id: "Fill-41",
    stroke: "none",
    fill: "#1D1D1B",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.6854,25.3716 C335.6514,33.1166 342.8114,45.8926 342.8114,60.3456 C342.8114,64.6306 342.1724,68.7556 341.0004,72.6686 C337.4884,84.4326 329.0504,94.0666 318.0844,99.1776 C314.4924,100.8806 310.6064,102.0786 306.5344,102.6906 C304.4044,103.0366 302.2214,103.1966 299.9864,103.1966 C276.3254,103.1966 257.1344,84.0066 257.1344,60.3456 C257.1344,42.7516 267.7544,27.6346 282.9254,21.0596 C287.9824,18.8506 293.5724,17.6006 299.4274,17.5466 C299.6144,17.5196 299.7994,17.5196 299.9864,17.5196 C309.1954,17.5196 317.7124,20.4216 324.6854,25.3716",
    id: "Fill-35",
    stroke: "none",
    fill: "#E8ECFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.3213,30.22 C263.5743,27.56 258.9973,26 254.0483,26 C253.9473,26 253.8473,26 253.7473,26.015 C250.6003,26.043 247.5963,26.716 244.8793,27.904 C236.7263,31.436 231.0183,39.561 231.0183,49.015 C231.0183,61.731 241.3323,72.043 254.0483,72.043 C255.2493,72.043 256.4223,71.957 257.5663,71.772 C259.7553,71.443 261.8423,70.799 263.7743,69.884 C269.6673,67.137 274.2013,61.96 276.0903,55.637 C276.7183,53.534 277.0613,51.318 277.0613,49.015 C277.0613,41.248 273.2153,34.382 267.3213,30.22 Z",
    id: "Stroke-44",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,53.8928 C216,71.2998 229.789,85.4038 246.781,85.4038",
    id: "Stroke-45",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.563,13.646 C63.466,14.284 64.056,15.336 64.056,16.527 C64.056,16.879 64.003,17.219 63.907,17.542 C63.618,18.511 62.922,19.304 62.019,19.725 C61.723,19.866 61.403,19.964 61.068,20.014 C60.892,20.043 60.712,20.056 60.529,20.056 C58.58,20.056 57,18.476 57,16.527 C57,15.078 57.874,13.833 59.124,13.292 C59.54,13.109 60,13.006 60.483,13.001 C60.498,13 60.513,13 60.529,13 C61.287,13 61.989,13.239 62.563,13.646",
    id: "Fill-27",
    stroke: "none",
    fill: "#F7A800",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.5332,
    y1: 48.744,
    x2: 105.6752,
    y2: -2.84217094e-14,
    id: "Stroke-29",
    stroke: "#1D1D1B",
    strokeWidth: 0.5,
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8.10018719e-13,
    y1: 68.8739,
    x2: 50.367,
    y2: 89.0789,
    id: "Stroke-31",
    stroke: "#F7A800",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308.375,
    y1: 78,
    x2: 270,
    y2: 116.374,
    id: "Stroke-32",
    stroke: "#F7A800",
    strokeWidth: 1,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongSign);
export default __webpack_public_path__ + "static/media/wrongSign.70814c2073041ccfaefb3f7c97c1698d.svg";
export { ForwardRef as ReactComponent };